export default __webpack_public_path__ + "static/media/2386.a69f9042.png";